import type { LayoutVariables } from '../types';
import { ReactComponent as Logo } from './styles/assets/kncv-logo.svg';

const layoutVariables: LayoutVariables = {
  logo: {
    LogoSVG: Logo,
  },
  basicPage: {
    breadcrumbsColClasses: 'col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2',
    heroTextColClasses: 'col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2',
  },
  homePage: {
    heroImageRatioXS: '9_16',
    heroImageRatioSM: '4_3',
    heroImageRatioMD: '4_3',
    heroImageRatioLG: '3_2',
    heroImageRatioXL: '16_9',
    heroTextColClasses: 'col-12 col-lg-6',
    heroQuicklinksColClasses: 'col-12',
    quickLinksButtonType: 'secondary',
  },
  landingPage: {
    heroImageRatioXS: '1_1',
    heroImageRatioSM: '16_9',
    heroImageRatioMD: '16_9',
    heroImageRatioLG: '16_9',
    heroImageRatioXL: '16_9',
    heroTextColClasses: 'col-12 col-lg-9 order-1',
    heroImageColClasses: 'col-full col-md-12 order-2',
  },
  overviewPage: {
    heroImageRatioXS: '16_9',
    heroImageRatioSM: '16_9',
    heroImageRatioMD: '16_9',
    heroImageRatioLG: '16_9',
    heroImageRatioXL: '16_9',
    breadcrumbsColClasses: 'col-12 col-md-10 col-lg-9',
    heroTextColClasses: 'col-12 col-md-10 col-lg-9',
    heroImageColClasses: 'col-full col-md-12',
  },
  profilePage: {
    heroImageRatioXS: '4_3',
    heroImageRatioSM: '4_3',
    heroImageRatioMD: '3_4',
    heroImageRatioLG: '3_4',
    heroImageRatioXL: '1_1',
    breadcrumbsColClasses: 'col-12',
    heroImageColClasses: 'col-12 col-md-5',
    heroDetailsColClasses: 'col-12 col-md-7',
    bodyBelowHero: true,
    // Only used if bodyBelowHero is true.
    heroBodyColClasses: 'col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2',
  },
  profileTeaser: {
    heroImageRatioXS: '1_1',
    heroImageRatioSM: '1_1',
    heroImageRatioMD: '1_1',
    heroImageRatioLG: '1_1',
    heroImageRatioXL: '1_1',
  },
  article: {
    heroImageRatioXS: '16_9',
    heroImageRatioSM: '16_9',
    heroImageRatioMD: '16_9',
    heroImageRatioLG: '16_9',
    heroImageRatioXL: '16_9',
    breadcrumbsColClasses: 'col-12 col-md-10 offset-md-1 col-lg-9 offset-lg-0',
    heroTextColClasses: 'col-12 col-md-10 offset-md-1 col-lg-9 offset-lg-0',
    heroImageColClasses: 'col-full col-md-12',
  },
  articleTeaser: {
    heroImageRatioXS: '1_1',
    heroImageRatioSM: '1_1',
    heroImageRatioMD: '1_1',
    heroImageRatioLG: '4_3',
    heroImageRatioXL: '4_3',
  },
  project: {
    heroImageRatioXS: '16_9',
    heroImageRatioSM: '16_9',
    heroImageRatioMD: '16_9',
    heroImageRatioLG: '16_9',
    heroImageRatioXL: '16_9',
    breadcrumbsColClasses: 'col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2',
    heroTextColClasses: 'col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2',
    heroImageColClasses: 'col-full col-md-12 col-lg-10 offset-lg-1',
  },
  projectTeaser: {
    heroImageRatioXS: '1_1',
    heroImageRatioSM: '1_1',
    heroImageRatioMD: '1_1',
    heroImageRatioLG: '4_3',
    heroImageRatioXL: '4_3',
  },
  paragraphTextMedia: {
    forceTopAlignmentVideoAudio: true,
    alignmentTopImageRatio: '16_9',
    alignmentLeftRightImageRatio: '4_3',
    mediaColClasses: 'col-12 col-md-6',
    mediaColClassesAlignmentRight: '',
    mediaColClassesAlignmentTop: 'col-md-10 offset-md-1 col-lg-8 offset-lg-2',
    textColClasses: 'col-12 col-md-6',
    textColClassesAlignmentLeft: '',
    textColClassesAlignmentTop: 'col-md-10 offset-md-1 col-lg-8 offset-lg-2',
  },
  paragraphLinkList: {
    imageRatio: '16_9',
    bodyColClasses: 'col-12 col-lg-8 offset-lg-2',
    linksColClasses: 'col-12',
  },
  paragraphQuote: {
    heroImageRatioXS: '1_1',
    heroImageRatioSM: '4_3',
    heroImageRatioMD: '1_1',
    heroImageRatioLG: '1_1',
    heroImageRatioXL: '1_1',
    imageColClasses: 'col-full col-md-6 col-lg-5',
    imageColClassesAlignmentRight: '',
    textColClassesWithImage: 'col-12 col-md-6 col-lg-7',
    textColClassesWithImageAlignmentLeft: '',
    textColClassesWithoutImage: 'col-md-10 offset-md-1 col-lg-8 offset-lg-2',
  },
  blockCTA: {
    heroImageRatioXS: '1_1',
    heroImageRatioSM: '1_1',
    heroImageRatioMD: '1_1',
    heroImageRatioLG: '1_1',
    heroImageRatioXL: '1_1',
    backgroundImageRatio: '3_2',
    imageColClasses: 'col-12 col-lg-6',
    textColClasses: 'col-12 col-lg-6',
    backgroundTextColClasses: 'col-12 col-xl-10 offset-xl-1',
  },
};

export default layoutVariables;
